import { html } from "lit";
import { query } from "lit/decorators.js";
import "../../atom/Icon/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let DsfPaginationSizeButton = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_options = [];
    this.dsf_open = false;
  }
  get textLabel() {
    return this.dsf_options.length ? this.dsf_options.join(", ") : "";
  }
  focus() {
    this.rootElement.focus();
  }
  render() {
    const arrowIconClasses = `h-12 w-12 shrink-0 transition-all ml-2 ${this.dsf_open ? "rotate-180" : ""}`;
    const selectContent = html`
      <span id="label" class="flex-auto truncate">${this.textLabel}</span>
    `;
    const icon = html`<dsf-icon dsf_name="ChevronDown" class=${arrowIconClasses}></dsf-icon>`;
    const buttonClasses = `
      flex 
      dsf-text-xxs-semibold 
      mr-4 
      items-center 
      p-4
      text-neutral-700
      outline-none
      rounded
      focus-within:shadow-focus-neutral-sm
      ${this.dsf_open ? "bg-neutral-200" : "hover:bg-neutral-100"}
    `;
    return html` <div id="root" class=${buttonClasses} tabindex="0">${selectContent} ${icon}</div> `;
  }
};
__decorateClass([
  prop({ type: Array })
], DsfPaginationSizeButton.prototype, "dsf_options", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfPaginationSizeButton.prototype, "dsf_open", 2);
__decorateClass([
  query("#root")
], DsfPaginationSizeButton.prototype, "rootElement", 2);
DsfPaginationSizeButton = __decorateClass([
  defineElement("dsf-pagination-size-button")
], DsfPaginationSizeButton);
export {
  DsfPaginationSizeButton
};
